import { KAPLAYCtx } from "kaplay";
import { GAME_WIDTH } from "../constants";
import { PALETTE, textStyle } from "../theme";

interface PulsingButtonOptions {
    label: string;
    y: number;
    pulseAmount: number; // fraction of full size the button grows and shrinks by
    onPress: () => void;
}

/** A large, horizontally centred call-to-action button that gently pulses. */
export function addPulsingButton(k: KAPLAYCtx, { label, y, pulseAmount, onPress }: PulsingButtonOptions): void {
    const button = k.add([
        k.rect(320, 68, { radius: 10 }),
        k.pos(GAME_WIDTH / 2, y),
        k.anchor("center"),
        k.color(...PALETTE.accent),
        k.outline(3, k.rgb(...PALETTE.white)),
        k.area(),
        k.scale(1),
    ]);

    const text = k.add([
        k.text(label, textStyle(24)),
        k.pos(GAME_WIDTH / 2, y),
        k.anchor("center"),
        k.color(...PALETTE.white),
        k.scale(1),
    ]);

    button.onUpdate(() => {
        const scale = 1 + Math.sin(k.time() * 6) * pulseAmount;
        button.scale = k.vec2(scale, scale);
        text.scale = k.vec2(scale, scale);
    });

    button.onClick(onPress);
}
